import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {getHttpParams} from '../helpers/request.helper';
import {ExportXmlModel} from '../models/export-xml.model';
import {ExportXmlModalComponent} from '../modules/admin/pages/export-xml/export-xml-modal/export-xml-modal.component';
import {clearFormValidationErrors} from '../helpers/form.helper';
import {ModalService} from './modal.service';
import {TranslateService} from '@ngx-translate/core';
import {ExportXmlActions} from '../state/export-xml/export-xml.actions';
import {NzModalRef} from 'ng-zorro-antd/modal';

@Injectable()
export class ExportXmlService {
    baseUrl = '/api/secured/policy/export';
    modalRef: NzModalRef;

    constructor(private http: HttpClient,
                private modalService: ModalService,
                private translateService: TranslateService
    ) {
    }

    exportXml(xmlData: ExportXmlModel) {
        return this.http.get(this.baseUrl, {params: getHttpParams(xmlData)});
    }

    openModal(ctx) {
        this.modalRef = this.modalService.generic({
            nzTitle: this.translateService.instant('EXPORT_XML.MODAL.TITLE'),
            nzContent: ExportXmlModalComponent,
            nzFooter: [
                {
                    label: this.translateService.instant('LABELS.CLOSE'),
                    type: 'default',
                    onClick: () => {
                        this.modalRef.close();
                        clearFormValidationErrors(ctx);
                    }
                },
                {
                    label: this.translateService.instant('EXPORT_XML.MODAL.CONFIRM'),
                    type: 'primary',
                    onClick: () => {
                        ctx.dispatch(new ExportXmlActions.Export());
                    },
                }
            ],
        });
    }

    closeModal() {
        if (this.modalRef) {
            this.modalRef.close();
        }
    }
}
